<template>
    <div>
        <a-modal :visible="isShow"  width="700px" title="修改尺寸" :footer="null" @cancel="cancel" class="resize_modal">
            <a-tabs type="card" v-model="curTab">
                <a-tab-pane v-for="resize in resizeList" :key="resize.type_id">
                    <template #tab>
                        <span :class="{'text_orange':isChckedType}">
                            {{resize.typename}}
                            <a-icon v-show="isChckedType(resize.type_id)" type="check" />
                        </span>
                    </template>
                    <div class="resize_check_wrapper">
                        <div class="resize_wrapper">
                            <div v-for="item in resize.list" :key="item.id">
                                <div v-if="(sizeType == 0 && (item.show_type == 0 || item.show_type == 1)) || (sizeType == 2 && (item.show_type == 0 || item.show_type == 2))">
                                    <div class="resize_item_wrapper">
                                        <div>
                                            <a-checkbox :value="item" :checked="isCheckedSize(item.id)" @change="(e)=>changeResize(resize.type_id,resize.typename,e)" />
                                            <span class="ml20">{{item.name}}</span>
                                            <img v-if="item.ico" :src="item.ico" width="17" height="17" class="ml5">
                                        </div>
                                        <span>{{`¥${item.price}/${item.unit}`}}</span>
                                    </div>
                                    <a-textarea v-if="isCheckedSize(item.id)" v-model="curSelectItem(resize.type_id).remark" :rows="3" :maxLength="255" :placeholder="resize.placeholder" />
                                </div>
                            </div>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <div class="btn_confirm">
                <a-button @click="cancel">取消</a-button>
                <a-button type="primary" class="ml20" @click="ok">确定修改</a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'ResizeModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        selectResize: {
            type: Array,
            required: false
        }
    },
    data () {
        return {
            curTab: '',
            resizeList: [],
            selectList: [],
            specInfo: {},
            sizeType: 0
        }
    },
    created () {
        this.getSizeList()
    },
    methods: {
        checkType(){
            var goods_name = this.specInfo.goods_name;console.log(goods_name);
            var res = 0;

            if(goods_name.indexOf('绒') !== -1 && goods_name.indexOf('植物羊绒') === -1){
                res = 2;
            }

            this.sizeType = res;
        },
        getSizeList () {
            this.$util.api('/size',{},res => {
                if(res.code == 10000){
                    var data = res.data;
                    var keys = Object.keys(data);
                    var res = [];

                    for(var i = 0; i < keys.length; i++){
                        for(var j = 0; j < data[keys[i]].length; j++){
                            data[keys[i]][j].remark = '';
                        }

                        res.push({
                            type_id: i,
                            typename: keys[i],
                            list: data[keys[i]]
                        });
                    }

                    this.curTab = res[0].type_id;
                    this.resizeList = res;
                }
            });
        },
        isChckedType (type_id) {
            return this.selectList.some(item => type_id === item.type_id)
        },
        isCheckedSize (id) {
            return this.selectList.some(item => id === item.id)
        },
        ok () {
            const item = this.selectList.find(({ remark }) => !remark)

            if (!this.$util.isEmpty(item)) {
                this.curTab = item.type_id
                this.$warning({
                    title: '提示',
                    content: '请将具体修改尺寸填写完整',
                })

                return
            }

            this.$emit('change', this.selectList)
            this.cancel()
        },
        cancel () {
            this.$emit('hidden', false)
        },
        changeResize (type_id, type_name, e) {
            const { value, checked } = e.target
            if (checked) {
                const index = this.selectList.findIndex(item => item.type_id === type_id)
                if (index === -1) {
                    this.selectList.push({ type_id, type_name, ...value })
                } else {
                    this.$set(this.selectList, index, { type_id, type_name, ...value })
                }
            } else {
                this.$util.deleteItem(this.selectList, type_id, 'type_id')
            }
        },
        curSelectItem (type_id) {
            return this.selectList.find(item => item.type_id === type_id)
        },
        defaultRemark (type_id) {
            const { remark } = this.selectList.find(item => item.type_id === type_id)
            return remark
        },
        changeRemark (type_id, e) {
            const { value } = e.target
            const resize = this.selectList.find(item => item.type_id === type_id)
            resize.remark = value
        },
    },
    watch: {
        isShow (val) {
            if (val && !this.$util.isEmpty(this.resizeList)) this.curTab = this.resizeList[0].type_id
        },
        selectResize: {
            handler (val) {
                this.selectList = val || []
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
.resize_modal {
    color: #333333;
}
.resize_modal ::v-deep .ant-tabs-nav .ant-tabs-tab {
    width: 110px;
    text-align: center;
    border-radius: 10px 10px 0 0;
}

.resize_modal ::v-deep .ant-tabs-nav .ant-tabs-tab .anticon {
    margin-right: 0;
}

.resize_modal ::v-deep .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active) {
    background: #ffefde;
}
.resize_modal >>> .ant-tabs-tab-active .text_orange {
    color: #ffffff;
}

.resize_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.resize_modal >>> .ant-table-thead th {
    background: #ffffff;
}

.resize_modal >>> .ant-table-tbody tr:nth-child(odd) {
    background: #fafafa;
}

.resize_check_wrapper {
    width: 100%;
    min-height: 378px;
    margin-top: 10px;
}
.resize_wrapper {
    border: 1px solid #ffefde;
}
.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    height: 35px;
    width: 100px;
}

.resize_item_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/order/ResizeModal.vue